export default __webpack_public_path__ + "eb8d524.png";